import React from 'react'
import Hero from './components/Hero'
import Foot from "./Navbar-footer/Foot";

const Home = () => {


  return (
    <div>
      <Hero/>
      <Foot/>
    </div>
  )
}

export default Home
